export const publicImageUrl = (path: string) =>
    process.env['PUBLIC_IMAGE_PATH']
        ? `${process.env['PUBLIC_IMAGE_PATH']}/images/${path}`
        : `/images/${path}`;
